<app-no-result
  [icon]="'notification_important'"
  [title]="noDataTitle"
  [description]="noDataTitle"
  [isButton]="false"
></app-no-result>
